import { useContext } from 'react';

import PropTypes from 'prop-types';

import { AuthContext } from '../../../../../actions/auth-context';

const StartPrintOrderButton = ({ order, has_fotolivro }) => {
  const { hasPermissions } = useContext(AuthContext);

  // Pode iniciar impressão quando:
  // - 'Edição aprovada' E o pedido NÃO tem fotolivro (segue direto p/ impressão);
  // - 'Edição de lâminas aprovada' (fotolivro, após o sub-fluxo de lâminas).
  const canStartPrint =
    (order.order_status === 'Edição aprovada' && !has_fotolivro) ||
    order.order_status === 'Edição de lâminas aprovada';

  return (
    <>
      {canStartPrint && hasPermissions(['print_photos']) && (
        <div className="col-sm col-md-4 col-xl-3 mt-2">
          <button
            className="btn btn-success btn-block col-12"
            type="button"
            data-bs-toggle="modal"
            data-bs-target="#modal-start-print-order"
          >
            iniciar impressão
          </button>
        </div>
      )}
    </>
  );
};

StartPrintOrderButton.propTypes = {
  order: PropTypes.shape({
    id: PropTypes.string,
    order_status: PropTypes.string,
  }).isRequired,
  has_fotolivro: PropTypes.bool,
};

StartPrintOrderButton.defaultProps = {
  has_fotolivro: false,
};

export default StartPrintOrderButton;
